import { GenericField } from "@/business/shared/commons/validator/validatorsTypes";

export function validator() {
  function validateField(
    field: GenericField,
    otherValue?: string
  ): GenericField {
    field.errors = field.rules
      .filter((rule) => !rule.check(field.val ?? "", otherValue))
      .map((rule) => {
        return {
          esMessage: rule.esValidationMessage,
        };
      });
    field.isSuccess = field.errors.length === 0;
    return field;
  }

  return {
    validateField,
  };
}
